import React, { Component } from 'react';
import { connect } from "react-redux";
import GuildsMenu from "components/guilds/GuildsMenu.js";
import TagInputComponent from 'components/tags/TagInputComponent.js';
import TagsChooserComponent from 'components/tags/TagsChooserComponent.js';
import TagClassifications from 'decentralized/TagClassifications.js';
import { Badge } from 'reactstrap';
import EthereumCache from 'decentralized/cache/EthereumCache.js';
import EthereumSoundsSearcher from 'search/EthereumSoundsSearcher.js';
import ipfs from 'decentralized/Ipfs.js';
import {TAG} from 'constants/field-types.js';
import '../../Tags.css';
import '../../Common.css';

const DRUM_MACHINES = [
    "707", "808", "909", "Access", "Casio", "Cheetah", "EMU", "Electro-Harmonix", "Elektron", "Elka",
    "Fairlight", "Farfisa", "Fricke", "Kawai", "Korg", "Linn", "Moog", "Nintendo", "Oberheim", "Roland"];
                       

const tagClassifications = new TagClassifications();

class TagsOrganizerComponent extends Component {
    constructor(props) {
        super(props);

        this.ethereumCache = new EthereumCache();
        this.ethereumSearcher = new EthereumSoundsSearcher(this.ethereumCache);

        this.state = {
            tagName : '',
            tagsChosen: [],
            tags: [],
            hierarchy: {},
            nextMode: false,
        };

        this.stack = [];
        this.tags = [];
        this.chosenSoFar= new Set();

        this.reloadEverything();
    }

    async reloadEverything(guildId=0) {
        await this.ethereumCache.loadNewIndex(guildId);
        this.loadTags();
        this.chosenSoFar = new Set();
        this.getHierarchy(guildId);
    }

    async getHierarchy(guildId=this.props.guildId) {
        console.log('getHierarchy called');
        /*
        this.setState({hierarchy: await tagClassifications.getClassifications(guildId)});

        Object.values(this.state.hierarchy).forEach(
            tags => 
                tags.forEach(tag => 
                             this.chosenSoFar.add(tag)));
        */

        this.autoBuild();
    }

    autoBuild() {
        console.log('auto build called with tags = ');
        console.log(this.state.tags);
        let hierarchy = {
            "Drum Machines": [],
            "Drums": ["kick", "snare", "hi-hat", "clap", "crash", "rim", "side-stick", "ride"],
        };
        for (let i in DRUM_MACHINES) {
            let drumMachine = DRUM_MACHINES[i];

            // find all tags with this in the name
            let tags = this.state.tags.filter(x => x !== drumMachine && x.includes(drumMachine));
            if (tags.length > 0) {
                hierarchy["Drum Machines"].push(drumMachine);
                hierarchy[drumMachine] = tags;
                tags.forEach(tag => this.chosenSoFar.add(tag));
                this.chosenSoFar.add(drumMachine);
            }
        }

        this.setState({
            hierarchy: {
                ... this.state.hierarchy,
                ... hierarchy,
            }
        });
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.guildId !== this.props.guildId) {
            this.reloadEverything(nextProps.guildId);
        }
        return true;
    }

    loadTags() {
        this.tags = this.ethereumCache.getAllForField(TAG, 0, 3000)
            .map(x => x.value);
        this.tags.sort();
        this.setState({tags:  this.tags});
    }

    onTagNameChanged(n) {
        if (this.state.tagsChosen.length > 0) {
            this.addTagsToHierarchy();
        }

        if (n in this.state.hierarchy) {
            this.setState({tagsChosen: this.state.hierarchy[n]});
        } else {
            this.setState({tagsChosen:  []});
        }
        this.setState({tagName: n});
    }

    onClickTag(tag) {
        if (this.state.nextMode) {
            // see if theres anything saved for that tag
            let ret = this.state.hierarchy[tag];
            ret = ret === undefined ? [] : ret;
            this.setState({
                tagName: tag,
                nextMode: false,
                tagsChosen: ret,
                tags: this.tags,
            });

            return;
        }
    
        let i = this.state.tagsChosen.indexOf(tag);
        if (i > -1) {
            let tags = this.state.tagsChosen;
            tags.splice(i, 1);
            this.setState({tagsChosen: tags});
        } else {
            this.setState({tagsChosen: this.state.tagsChosen.concat([tag])})
        }
    }

    addTagsToHierarchy(n=this.state.tagName) {
        let hierarchy = Object.assign(this.state.hierarchy, {});
        hierarchy[this.state.tagName] = this.state.tagsChosen;
        console.log('adding to ' + this.state.tagName + ' tags =');
        console.log(this.state.tagsChosen);
        this.state.tagsChosen.forEach(
            tag => this.chosenSoFar.add(tag));
        
        this.setState({hierarchy: hierarchy});
        console.log('hierarchy = ');
        console.log(hierarchy);
        
    }

    goBackUpLevel() {
        this.addTagsToHierarchy();

        if (this.stack.length == 0) {
            this.setState({
            nextMode: false,
            tagName: '',
            tags: this.tags,
            tagsChosen: []
            });
            return;
        }

        let popped = this.stack.pop();
        this.setState({
            nextMode: false,
            tagName: popped.name,
            tags: this.tags,
            tagsChosen: popped.tags
        });
    }

    goDownLevel() {
        if (!this.state.nextMode) {
            this.stack.push({name: this.state.tagName,
                             tags: this.state.tagsChosen});
            this.addTagsToHierarchy();
            this.setState({
                nextMode: true,
                tagsChosen: [],
                tags: this.state.tagsChosen,
                      });
        }
    }

    getRelevantTags() {
        this.setState({
            tags: Array.from(this.ethereumCache.getFieldsForField(TAG, TAG, this.state.tagName)).sort(),
        });
    }

    clearRelevantTags() {
        this.setState({
            tags: this.tags,
        });
    }

    async saveHierarchy() {
        //let hash = await ipfs.addJson(this.state.hierarchy);
        console.log('saving the tags classification = ');
        console.log(this.state.hierarchy);
        delete this.state.hierarchy[''];
        let hash = await tagClassifications.saveClassifications(this.props.guildId, this.state.hierarchy);
   }

    deleteCategory() {
        let newHierarchy = {...this.state.hierarchy};
        let tags = newHierarchy[this.state.tagName];
        delete newHierarchy[this.state.tagName];
        tags.forEach(tag => delete newHierarchy[tag]);
        console.log('new hierarchy = ');
        console.log(newHierarchy);
        this.setState({
            hierarchy: newHierarchy,
            tagName: ''
                      });
    }

    render() {
        return (
            <div>
              <div className="tags-navigator">
                <div className="header">TAGS ORGANIZER</div>
                <GuildsMenu/>
              </div>
              <TagInputComponent
                tag={this.state.tagName}
                onTagNameChanged={(n) => this.onTagNameChanged(n)}/>
                <div className="info-text">{this.stack.length} deep and {this.chosenSoFar.size}/{this.tags.length} tags done</div>
              <div>
                {this.state.tagsChosen.map((tag) => <Badge color="light">{tag}</Badge>)}
              </div>
              <div
                className="common-button light-blue-button"
                onClick={() => this.goDownLevel()}>
                DOWN LEVEL
              </div>
              <div
                className="common-button light-blue-button"
                onClick={() => this.goBackUpLevel()}>
                UP LEVEL
              </div>  
              <div
                className="common-button light-blue-button"
                onClick={() => this.getRelevantTags()}>
               GET RELEVANT TAGS 
              </div>
              <div
                className="common-button light-blue-button"
                onClick={() => this.clearRelevantTags()}>
                CLEAR RELEVANT TAGS
              </div>
              <div
                className="common-button light-blue-button"
                onClick={() => this.deleteCategory()}>
                DELETE CATEGORY
              </div>
              <div
                className="common-button light-blue-button"
                onClick={() => this.saveHierarchy()}>
                SAVE
              </div>
             <TagsChooserComponent
                  tags={this.state.tags}
                  chosenSoFar={this.chosenSoFar}
                  tagsChosen={this.state.tagsChosen}
                  onClickTag={(tag) => this.onClickTag(tag)}/>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        guildId: state.guilds.selectedGuild ? state.guilds.selectedGuild.guildId : 0
    };
};

export default connect(mapStateToProps, null)(TagsOrganizerComponent);
